import { useRef } from 'react'
import ReactPortal from 'components/Commons/ReactPortal'
import useFreezeBody from 'hooks/useFreezeBody'
import { GoToTop } from 'components/Commons/GoToTop'

import { Container, Close } from './styled'

function ModalSwitch({ id, open, children, onClose }) {
  const scrollRef = useRef()
  useFreezeBody(open)

  function handleClose() {
    if (onClose) onClose()
  }

  return (
    <ReactPortal id={id}>
      {open && (
        <Container ref={scrollRef}>
          {onClose && <Close onClick={handleClose} />}
          {children}
          <GoToTop element={scrollRef.current} />
        </Container>
      )}
    </ReactPortal>
  )
}

export default ModalSwitch
